/**
 * React DevTools 에 노출할 이름을 붙인다.
 *
 * `SList.displayName = 'SList'` 처럼 **최상위 대입문**으로 쓰면 번들러가 이를
 * 부작용으로 보고 지우지 못한다. 그러면 그 컴포넌트와 컴포넌트가 참조하는 것
 * 전부(예: SIcon → 아이콘 89개)가 소비 앱 번들에 남는다.
 *
 * 선언식 안으로 밀어 넣으면 `/* @__PURE__ *\/` 를 붙일 수 있어 안 쓰는 컴포넌트가
 * 통째로 제거된다. 주석은 scripts/annotate-pure.mjs 가 빌드 후 넣는다.
 *
 * ```ts
 * export const SList = withDisplayName(forwardRef(...), 'SList');
 * ```
 *
 * ⚠️ 방금 만든 컴포넌트에만 쓴다. 이미 다른 곳에서 쓰이는 값에 붙이면 pure 로
 * 표시한 것이 거짓이 되어, 지워지면 안 될 대입이 사라질 수 있다.
 */
export function withDisplayName<T>(component: T, name: string): T {
  (component as { displayName?: string }).displayName = name;
  return component;
}
